import { useEffect, useState } from 'preact/hooks'
import { EMAIL_REG_EXP } from '../constants'
import { getEmail } from '../utils'

function useEmailControl() {
  const [isPolicyAccepted, setIsPolicyAccepted] = useState(false)
  const [hasEmailFilled, setHasEmailFilled] = useState(false)
  const [requiredEmail, setRequiredEmail] = useState('')

  useEffect(() => {
    if (isPolicyAccepted && EMAIL_REG_EXP.test(requiredEmail)) {
      setHasEmailFilled(true)
    }

    if (!isPolicyAccepted && !EMAIL_REG_EXP.test(requiredEmail)) {
      setHasEmailFilled(false)
    }
  }, [isPolicyAccepted])

  useEffect(() => {
    const callBack = ({ detail }) => {
      const email = getEmail(detail)
      setHasEmailFilled(EMAIL_REG_EXP.test(email))
    }

    window.addEventListener('actioncard-change', callBack)
    return () => {
      window.removeEventListener('actioncard-change', callBack)
    }
  }, [])

  return {
    isPolicyAccepted,
    hasEmailFilled,
    requiredEmail,
    setIsPolicyAccepted,
    setHasEmailFilled,
    setRequiredEmail,
  }
}

export default useEmailControl
